'use strict';

export class Checkout {
    #levcharity_donation_checkout_fields;
    #levcharity_donation_checkout_ajax_fields;
    #search_team_field;
    #admin_ajax;
    #donation_frequency_monthly_input;

    //variables for managing fetch requests
    #is_fetching = false;
    #is_fetching_predifined_amount = false;
    #is_fetching_donation_currency = false;

    //Team Campaign
    #team_and_participant_results;
    #search_team_and_participant_input;

	#isUpdating = false;
    // Gift Aid
    #gift_aid_wrapper;

    constructor() {
        //Add 'levcharity-donation-checkout-ajax-field' class to your element for ajax requests
        this.#levcharity_donation_checkout_fields = document.querySelector('.levcharity-donation-checkout-fields');

        this.#levcharity_donation_checkout_ajax_fields = document.querySelectorAll('.levcharity-donation-checkout-ajax-field');
        this.#search_team_field = document.querySelector('#search_team_and_participant');
        this.#admin_ajax = admin_ajax[0];
        this.#donation_frequency_monthly_input = document.querySelector('#donation_frequency_monthly');

        //Team Campaign team and participantresults
        this.#team_and_participant_results = document.querySelectorAll('.form-team-search-result--item');
        this.#search_team_and_participant_input = document.querySelector('#search_team_and_participant');

        //Gift Aid
        this.#gift_aid_wrapper = document.querySelector('.levcharity_form__field.donation_gift_aid_wrapper');

        if(this.#levcharity_donation_checkout_fields) {
            this.addEvents();
        }
    }

    addEvents() {
        if (this.#levcharity_donation_checkout_ajax_fields && this.#admin_ajax) {
			const additionalFee = document.querySelector('input[name="additional_fee"]:checked');
			if(additionalFee) {
				this.handleAdditionalFeeChange(additionalFee);
			}
            this.#levcharity_donation_checkout_ajax_fields.forEach((field, index) => {
                let fieldTagName = field.tagName.toLowerCase();
                if (fieldTagName === 'input') {
                    let fieldType = field.type;

                    if (fieldType === 'radio') {

                        field.addEventListener('change', (event) => {
                            event.preventDefault();
                            let fieldName = field.getAttribute('name');
                            let fieldValue = field.getAttribute('data-value');
                            let checkoutUpdate = field.getAttribute('data-update');

                            if (fieldName && fieldValue) {
                                if (fieldName === 'predefined_amount') {
                                    // Empty custom amount input when predefined amount is selected
                                    this.emptyCustomAmount();
                                    this.predefinedAmountFetch(fieldName, fieldValue, checkoutUpdate);
                                } else if (fieldName === 'additional_fee'){
									this.handleAdditionalFeeChange(field);
								} else {
                                    this.changeOrderDetailsRequest(fieldName, fieldValue, checkoutUpdate);
                                }
                            }
                        });
                    } else if (fieldType === 'text' || fieldType === 'number' || fieldType === 'email') {
                        let fieldTypeTimeout;

                        field.addEventListener('input', (event) => {
                            event.preventDefault();
                            let fieldName = field.getAttribute('name');
                            let fieldValue = field.value;
                            let checkoutUpdate = field.getAttribute('data-update');

                            clearTimeout(fieldTypeTimeout);
                            fieldTypeTimeout = setTimeout(() => {
                                if (fieldName && fieldValue) {
                                    if (fieldName === 'custom_amount') {
                                        //Empty predefined amounts when custom amount is not empty
                                        this.emptyPredefinedAmount();
                                    }
                                    this.changeOrderDetailsRequest(fieldName, fieldValue, checkoutUpdate);
                                }
                            }, 1000);
                        });
                    } else if (fieldType === 'checkbox') {
                        field.addEventListener('change', (event) => {
                            event.preventDefault();
                            let fieldName = field.getAttribute('name');
                            let fieldValue = event.target.checked;
                            let checkoutUpdate = field.getAttribute('data-update');
                            if (fieldName && (fieldValue || fieldValue === false)) {
                                this.changeOrderDetailsRequest(fieldName, fieldValue, checkoutUpdate);
                            }
                        });
                    } else if (fieldType === 'file') {
                        field.addEventListener('change', (event) => {
                            event.preventDefault();
                            let fieldName = field.getAttribute('name');
                            let fieldValue = field.files;
                            if (fieldName && (fieldValue || fieldValue === false)) {
                                this.changeOrderDetailsRequest(fieldName, fieldValue, true, true);
                            }
                        });
                    }
                } else if (fieldTagName === 'textarea') {
                    let fieldTypeTimeout;
                    field.addEventListener('input', (event) => {
                        event.preventDefault();
                        let fieldName = field.getAttribute('name');
                        let fieldValue = field.value;
                        let checkoutUpdate = field.getAttribute('data-update');

                        clearTimeout(fieldTypeTimeout);
                        fieldTypeTimeout = setTimeout(() => {
                            if (fieldName && fieldValue) {
                                this.changeOrderDetailsRequest(fieldName, fieldValue, checkoutUpdate);
                            }
                        }, 1000);
                    });
                } else if (fieldTagName === 'select') {
					if(!this.#isUpdating && field.getAttribute('name') == 'user_paying_currency'){
						this.changeOrderDetailsRequest(field.getAttribute('name'), field.value, true);
						this.#is_fetching = true;
					}
                    field.addEventListener('change', (event) => {
                        event.preventDefault();
                        let fieldName = field.getAttribute('name');
                        let fieldValue = field.value;
                        let checkoutUpdate = field.getAttribute('data-update');
                        if (fieldName && fieldValue) {
                            if(fieldName === 'user_paying_currency'){
                                this.donationCurrencyFetch(fieldName, fieldValue, checkoutUpdate);
                            }else{
                                this.changeOrderDetailsRequest(fieldName, fieldValue, checkoutUpdate);
                            }
                        }
                    });
                }
            });
        }

		document.addEventListener('change', (event) => {
			if (event.target.matches('input[type="radio"][name="payment_method"]')) {
				setTimeout(() => {
					document.body.dispatchEvent(new Event('update_checkout'));
				}, 500)
			}
		})

        if (this.#team_and_participant_results && this.#admin_ajax && this.#search_team_and_participant_input) {
            this.#team_and_participant_results.forEach((item) => {
                item.addEventListener('click', (e) => {
                    let value = item.getAttribute('data-value') ?? '';
                    let teamName = item.getAttribute('data-teamName') ?? '';
                    let memberName = item.getAttribute('data-memberName') ?? '';
                    let team_id = item.getAttribute('data-team') ?? 0;
                    let member_id = item.getAttribute('data-member') ?? 0;
                    let searchInputParentContainer = this.#search_team_and_participant_input.closest('.form-team-search');
                    this.#search_team_and_participant_input.value = '';

                    let inputEvent = new Event('input', {
                        bubbles: true,
                        cancelable: true
                    });
                    this.#search_team_and_participant_input.dispatchEvent(inputEvent);

                    //remove all selected blocks
                    this.removeSelectedBlocks();
                    this.removeTopBannerTeamAndMemberInfo();

                    //create new selected block
                    let newSelectedInfoBlock = document.createElement('div');
                    newSelectedInfoBlock.innerText = value;
                    newSelectedInfoBlock.classList.add('selected-team-block');
                    searchInputParentContainer.append(newSelectedInfoBlock);

                    this.changeOrderDetailsRelatedToTeam( team_id, member_id);

                    let topBannerTextContainer = document.querySelector('.levcharity-donation-checkout-top > div:last-child');
                    if(teamName){
                        let selectedTeamNameParagraph = document.createElement('p');
                        selectedTeamNameParagraph.classList.add('checkout-selected-team-name-paragraph');
                        selectedTeamNameParagraph.innerHTML = "<strong>Team: </strong>" + "<span class='checkout-selected-team-name'>"+ teamName +"</span>";
                        if(topBannerTextContainer){
                            topBannerTextContainer.appendChild(selectedTeamNameParagraph);
                        }
                    }
                    if(memberName){
                        let selectedMemberNameParagraph = document.createElement('p');
                        selectedMemberNameParagraph.classList.add('checkout-selected-member-name-paragraph');
                        selectedMemberNameParagraph.innerHTML = "<strong>Member: </strong>" + "<span class='checkout-selected-member-name'>"+ memberName +"</span>";
                        if(topBannerTextContainer){
                            topBannerTextContainer.appendChild(selectedMemberNameParagraph);
                        }
                    }

                    let itemsWrapper = item.closest('.form-team-search-results-container');
                    if(itemsWrapper){
                        itemsWrapper.style.display = 'none';
                    }
                });
            });
        }
        document.addEventListener('click', (event) => {
            if( event.target.matches('.selected-team-block') || event.target.closest('.selected-team-block') ) {
                this.removeSelectedBlocks();
                this.removeTopBannerTeamAndMemberInfo();
                this.changeOrderDetailsRelatedToTeam( 0, 0);
            }
        });

        document.addEventListener('click', event => {
            if (event.target.matches('form.woocommerce-checkout button[name="woocommerce_checkout_place_order"]') || event.target.closest('form.woocommerce-checkout button[name="woocommerce_checkout_place_order"]')) {
                document.querySelectorAll('.levcharity-custom-field[required]')?.forEach(field => {
                    if (['radio', 'checkbox'].includes(field?.type)) {
                        if (!field.checked) {
                            field.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            field.focus();
                            event.preventDefault();
                        }
                    } else {
                        if (!field.value) {
                            field.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            field.focus();
                            event.preventDefault();
                        }
                    }
                });

                let tribute_checkout = document.querySelector('#donation_tribute');
                if(tribute_checkout && tribute_checkout.checked) {
                    let donation_tribute_type = document.querySelector('#donation_tribute_type');
                    let tributeTextInputIDs= ['donation_tribute_name', 'donation_tribute_certificate_name', 'donation_tribute_certificate_email', 'donation_tribute_certificate_message'];

                    if(donation_tribute_type && donation_tribute_type.value === 'default') {
                        donation_tribute_type.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        donation_tribute_type.focus();
                        event.preventDefault();
                    }
                    tributeTextInputIDs.forEach((fieldId)=>{
                        let  field = document.querySelector(`#${fieldId}`);
                        if(field && field.value === '') {
                            field.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            field.focus();
                            event.preventDefault();
                        }
                    });
                }
            }
        });

        if(this.#donation_frequency_monthly_input){
            this.#donation_frequency_monthly_input.addEventListener('change', (event) => {
                if(event.target.checked) {
                    let donation_frequency_period = document.querySelector('#donation_frequency_period');
                    if(donation_frequency_period){
                        let event = new Event('change');
                        donation_frequency_period.dispatchEvent(event);
                    }
                }
            });
        }

        if(this.#gift_aid_wrapper) {
            let user_paying_currency = document.querySelector('[name="user_paying_currency"]');

            if(user_paying_currency) {
                let currency_currency = user_paying_currency.value;
                if(currency_currency === 'GBP') {
                    this.#gift_aid_wrapper.classList.remove('hidden');
                }

                user_paying_currency.addEventListener('change', (event)=>{
                    let changed_currency = user_paying_currency.value;

                    if(changed_currency !== 'GBP') {
                        this.#gift_aid_wrapper.classList.add('hidden');
                    }else{
                        this.#gift_aid_wrapper.classList.remove('hidden');
                    }
                });
            }

        }
    }

    async changeOrderDetailsRequest(fieldName, fieldValue, checkoutUpdate = false, is_file = false) {
        if (this.#is_fetching) {
            // If the function is already in process, wait until it's done before calling it again.
            await this.waitForProcessing();
        }

        this.#is_fetching = true;

        let formData = new FormData();

        if (is_file) {
            for (const file of fieldValue) {
                formData.append(`${fieldName}[]`, file);
            }
        } else {
            formData.append(fieldName, fieldValue);
        }
        formData.append('action', 'levcharity_donatation_checkout_update');

		const donationAmountsWrapper = document.querySelector(`.levcharity_form__donation_amount_wrapper`);
		if(donationAmountsWrapper) {
			formData.append('donation_product_id', donationAmountsWrapper.dataset.id);
		}
        //to avoid from cache
        let currentDate = new Date();
        formData.append('time', currentDate.getTime());

        try {
            const response = await fetch(this.#admin_ajax, {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
            });

            const data = await response.json();

            if (data.success) {
                if (data.updated_items) {
                    for (const item_key in data.updated_items) {
                        let item_container = document.querySelector(`div[data-id="${item_key}"]`);
                        if ( item_container ) {
                            item_container.querySelector('.currency-symbol').innerHTML = data.updated_items[item_key].currency_symbol;
                            item_container.querySelector('.equipment-amount').innerText = data.updated_items[item_key].price;
                        }
                    }
                }

                // If need checkout update
                if (checkoutUpdate) {
                    // Triggering update_checkout to update woocommerce form
                    document.body.dispatchEvent(new Event('update_checkout'));
                }

				if (data.total)  {
					const checkoutForm = document.querySelector('form[name="checkout"]');
					checkoutForm?.setAttribute('data-total', data.total)
				}
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setTimeout(()=>{
                this.#is_fetching = false;
            }, 1000);
        }
    }

    waitForProcessing() {
        return new Promise(resolve => {
            const checkProcessing = () => {
                if (!this.#is_fetching) {
                    resolve();
                } else {
                    setTimeout(checkProcessing, 100); // Check again after a short delay
                }
            };

            checkProcessing();
        });
    }

    changeOrderDetailsRelatedToTeam(team_id = 0, member_id = 0) {

        let formData = new FormData();

        formData.append('action', 'levcharity_donatation_checkout_update');
        formData.append('_team_id', team_id);
        formData.append('_member_id', member_id);
        formData.append('time', new Date());

        fetch(this.#admin_ajax, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    if (data.updated_items) {
                        for (const item_key in data.updated_items) {
                            let item_container = document.querySelector(`div[data-id="${item_key}"]`);
                            if ( item_container ) {
                                item_container.querySelector('.currency-symbol').innerHTML = data.updated_items[item_key].currency_symbol;
                                item_container.querySelector('.equipment-amount').innerText = data.updated_items[item_key].price;
                            }
                        }
                    }
                    //if need checkout update
                    if (checkoutUpdate) {
                        //Triggering update_checkout to update woocommerce form
                        document.body.dispatchEvent(new Event('update_checkout'));
                    }
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }

    predefinedAmountFetch(fieldName, fieldValue, checkoutUpdate)
    {
        clearTimeout(this.#is_fetching_predifined_amount);
        this.#is_fetching_predifined_amount = setTimeout(()=>{
            this.changeOrderDetailsRequest(fieldName, fieldValue, checkoutUpdate);
        }, 1000);
    }

    donationCurrencyFetch(fieldName, fieldValue, checkoutUpdate)
    {
        clearTimeout(this.#is_fetching_donation_currency);
        this.#is_fetching_donation_currency = setTimeout(()=>{
            this.changeOrderDetailsRequest(fieldName, fieldValue, checkoutUpdate);
        }, 1000);
    }

    emptyCustomAmount() {
        let customAmountInput = document.querySelector('input[name="custom_amount"]');
        if (customAmountInput) {
            customAmountInput.value = '';
        }
    }

    emptyPredefinedAmount() {
        let predefinedAmountsRadioButtons = document.querySelectorAll('input[name="predefined_amount"]');
        if (predefinedAmountsRadioButtons) {
            predefinedAmountsRadioButtons.forEach((predefinedAmountsRadioButton, index) => {
                predefinedAmountsRadioButton.checked = false;
            });
        }
    }

	handleAdditionalFeeChange(additionalFee) {
		let fieldFeeName = additionalFee.getAttribute('data-fee');
		let fieldName = additionalFee.getAttribute('name');
		let fieldValue = additionalFee.getAttribute('data-value');
		let checkoutUpdate = additionalFee.getAttribute('data-update');
		this.changeOrderDetailsRequest(fieldName, fieldValue, checkoutUpdate);
		this.changeOrderDetailsRequest('additional_fee_name', fieldFeeName, checkoutUpdate);
	}

    removeSelectedBlocks() {
        let selectedBlocks = document.querySelectorAll('.selected-team-block');
        if(selectedBlocks){
            Array.from(selectedBlocks).forEach(element => element.remove());
        }
    }

    removeTopBannerTeamAndMemberInfo(){
        let selectedTeamParagraph = document.querySelector('.checkout-selected-team-name-paragraph');
        let selectedMemberParagraph = document.querySelector('.checkout-selected-member-name-paragraph');

        if(selectedMemberParagraph){
            selectedMemberParagraph.remove();
        }
        if(selectedTeamParagraph){
            selectedTeamParagraph.remove();
        }
    }
}
